/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (!environment.production) {
  /*
   * Local development only. The debug token printed in the browser console
   * must be registered in Firebase App Check debug tokens. Never commit a
   * fixed debug token value here and never use debug tokens in production.
   */
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
